import { useEffect, useRef } from 'react';

const BEFORE_UNLOAD_EVENT_NAME = 'beforeunload';

/**
 * This hook will prompt the user with a message if they try to navigate away from the page or refresh the page
 *
 * @param  hasUnsavedChanges - whether or not to show the prompt
 * @param  message - the message to show the user
 */
export const useUnsavedChangesPrompt = (hasUnsavedChanges: boolean, message?: string) => {
  const onBeforeUnloadRef = useRef<EventListener>();

  useEffect(() => {
    if (onBeforeUnloadRef.current) {
      window.removeEventListener(BEFORE_UNLOAD_EVENT_NAME, onBeforeUnloadRef.current);
    }
    onBeforeUnloadRef.current = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
    };
  }, [message]);

  useEffect(() => {
    if (hasUnsavedChanges && onBeforeUnloadRef.current) {
      window.addEventListener(BEFORE_UNLOAD_EVENT_NAME, onBeforeUnloadRef.current);
    } else if (onBeforeUnloadRef.current) {
      window.removeEventListener(BEFORE_UNLOAD_EVENT_NAME, onBeforeUnloadRef.current);
    }

    return () => {
      if (onBeforeUnloadRef.current) {
        window.removeEventListener(BEFORE_UNLOAD_EVENT_NAME, onBeforeUnloadRef.current);
      }
    };
  }, [hasUnsavedChanges, message]);
};
